import { Transition } from '@uirouter/core';
import { Action } from '../../common/actions/core/action';
import { FamilyPlanTypes } from '../../common/services/package/package.model';

export class ManageContactsDeleteDialogAction implements Action {
  constructor(
    public subId: number,
    public type: FamilyPlanTypes
  ) {}
}



// WEBPACK FOOTER //
// src/app/family-plan/manage-contacts-delete-dialog/manage-contacts-delete-dialog.action.ts